import { Button, DateField, Typography } from "@hellocarbo/lasagne";
import { addMonths, subDays } from "date-fns";
import { Calendar } from "lucide-react";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

import { PortalContainerContext } from "@/contexts";

type PeriodProps = {
  defaultStartDate: Date;
  errorMessage?: string;
  loading?: boolean;
  onBackButtonClick: () => void;
};

function Period({
  defaultStartDate,
  errorMessage,
  loading = false,
  onBackButtonClick,
}: PeriodProps) {
  const { t, i18n } = useTranslation(["common", "externalCampaign"]);
  const { container } = useContext(PortalContainerContext);

  const [startDate, setStartDate] = useState<Date>(defaultStartDate); // get the day after the end of the last campaign

  const endDate = subDays(addMonths(startDate, 12), 1); // get the day after the end of the last campaign

  const onDateChange = (value: Date) => {
    setStartDate(value);
  };

  return (
    <>
      <Typography className="mb-lg">
        {t("externalCampaign:startDate.description")}
      </Typography>
      <div className="gap-y-lg flex flex-col">
        <DateField
          name="startDate"
          language={i18n.language as "fr" | "en"}
          defaultValue={defaultStartDate}
          label={t("externalCampaign:footprintStartDate")}
          popoverProps={{ portalContainer: container as Element }}
          onChange={onDateChange}
        />
        <div className="flex justify-center">
          <Calendar className="size-md" />
          &nbsp;
          <Typography>
            {t("externalCampaign:coveredPeriod")}
            <Typography as="span" weight="bold" className="ml-3xs text-primary">
              {t("formatter:date", {
                value: startDate,
              })}
              &nbsp;-&nbsp;
              {t("formatter:date", {
                value: endDate,
              })}
            </Typography>
          </Typography>
        </div>
        <div className="text-center">
          {errorMessage && (
            <div className="mb-lg bg-negative-xx-light p-2xs rounded-md text-start">
              <Typography className="text-grayscale-dark">
                {t(errorMessage)}
              </Typography>
            </div>
          )}
          <div className="mt-lg gap-x-sm flex justify-center">
            <Button shape="link" onClick={onBackButtonClick}>
              {t("common:back")}
            </Button>
            <Button type="submit" isLoading={loading}>
              {t("common:next")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Period;
